import ChatFeed from './ChatFeed';

export default ChatFeed;
